export const parameterize = (string: string) => string.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, '').replace(/\s/g, '-')

export const capitalizeWords = (string: string) => string.toLowerCase()
  .split(/\s+/)
  .map(s => s.charAt(0).toUpperCase() + s.substring(1))
  .join(' ')

// https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest#converting_a_digest_to_a_hex_string
export const digestSha256 = async (string: string) => {
  const msgUint8 = new TextEncoder().encode(string) // encode as (utf-8) Uint8Array
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgUint8) // hash the message
  const hashArray = Array.from(new Uint8Array(hashBuffer)) // convert buffer to byte array
  return hashArray
    .map(b => b.toString(16).padStart(2, '0'))
    .join('') // convert bytes to hex string
}
